<template>
  <div v-if="$data.$local.chat.activators">
    <vx-card :title="$t('advisor-chat.chatroom.title')"
      collapseAction refreshContentAction
    >
      <Chat :activator="$data.$local.chat.activators" :dev="true" />
    </vx-card>
  </div>
<!--  <div v-else>-->
<!--    {{ $data.$local }}-->
<!--    </div>-->
</template>

<script>
import state from "../../data";

// console.log(state);

export default {
  components: {
    Chat: () => import("@/developing/components/chat")
  },
  data() {
    return {
      $local: state
    }
  }
}
</script>

<style>

</style>
